import { render, staticRenderFns } from "./edit.venue-events-lists.page.vue?vue&type=template&id=aa6e5f20&"
import script from "./edit.venue-events-lists.page.vue?vue&type=script&lang=js&"
export * from "./edit.venue-events-lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports